// extracted by mini-css-extract-plugin
export default {"content":"content-yarixko8","leftColumn":"leftColumn-dEjR8n8P","rightColumn":"rightColumn-lqWL9MAS"};